//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import waaromLidGewordenOpties from '~/graphql/queries/waaromLidGewordenOpties.gql';

export default {
  name: 'Persoonsgegevens',
  apollo: {
    waaromLidGewordenOpties: {
      query: waaromLidGewordenOpties,
    },
  },
  data: () => ({
    waaromLidGewordenOpties: [],
  }),
  computed: {
    whyOptions() {
      return this.waaromLidGewordenOpties.map(option => ({value: option.id, label: option.title}));
    },
  },
};
